import { AxiosInstance } from 'axios';

import { Preference } from '../../types/Preference';
import { preferencesEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { CreatePreferencesInput } from './PreferencesApi.schema';

class PreferencesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  createMany = async (createPreferencesInput: CreatePreferencesInput): Promise<Preference[]> => {
    return this.#requestInstance.post(preferencesEndpoints.preferences, createPreferencesInput);
  };

  getPreferencesByUserId = async (userId: number): Promise<Preference[]> => {
    return this.#requestInstance.get(preferencesEndpoints.getPreferencesByUserId(userId));
  };

  deleteByUserId = async (userId: number): Promise<void> => {
    return this.#requestInstance.delete(preferencesEndpoints.getPreferencesByUserId(userId));
  };
}

export const preferencesApi = new PreferencesApi(axios);
